var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_71",
    x: 0,
    y: 0,
    width: 53,
    height: 53,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "next",
    transform: "translate(44 41) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 44, 41)",
    filter: "url(#Path_71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71-2",
    "data-name": "Path 71",
    d: "M17.5,0A17.5,17.5,0,1,0,35,17.5,17.519,17.519,0,0,0,17.5,0Zm5.406,18.531-7.292,7.292a1.458,1.458,0,0,1-2.062-2.062L19.813,17.5l-6.261-6.261a1.458,1.458,0,1,1,2.062-2.062l7.292,7.292A1.457,1.457,0,0,1,22.906,18.531Z",
    transform: "translate(44 41) rotate(180)",
    fill: "#4e4e4e"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftNext);
export default __webpack_public_path__ + "static/media/leftNext.515fbae51c6a0bf3419e035829e92401.svg";
export { ForwardRef as ReactComponent };